<template>
  <div>
    <div class="header-wrapper-exception hawk-banner">
      <h2>Hawk Performance</h2>
      <hr class="line" />
    </div>

    <b-container>
      <div class="grid">
        <div class="text">
          <p>
            Marka Hawk Performance została stworzona przez Wellman Products
            Group, światowego lidera w produkcji materiałów ciernych słynącego z
            najwyższej jakości swoich produktów. Wellman Products Group od
            prawie 100 lat projektuje i wytwarza elementy do systemów
            hamulcowych i układów przeniesienia napędu dla przemysłu lotniczego,
            aeronautycznego, kolejowego, wydobywczego, wojskowego oraz
            motoryzacyjnego, włączając w to produkty stosowane w sporcie
            wyczynowym.
          </p>
          <p>
            Gdziekolwiek mamy do czynienia z przeniesieniem momentu obrotowego i
            mocy tam znajdziesz również Wellman Products Group. Produkty Hawk
            Performance zostały wprowadzone najpierw na areny rajdów
            samochodowych ponad 20 lat temu z miejsca deklasując konkurencję i
            zdobywając serca najlepszych zawodników. Niedługo potem przyszła
            kolej na zastosowanie swoich unikalnych technologii w produktach
            przeznaczonych do aut seryjnych - efekt był oczywiście podobny.
            Marka Hawk Performance podbiła już Amerykę gdzie cieszy się większą
            renomą niż jakikolwiek inny, europejski czy japoński producent
            klocków hamulcowych.
          </p>
        </div>
        <div class="image">
          <picture>
            <source
              type="image/webp"
              srcset="./../../assets/brands-logos/p10_hawk.webp"
            />
            <img src="./../../assets/brands-logos/p10_hawk.png" alt="Hawk" />
          </picture>
        </div>
      </div>
    </b-container>

    <page-header
      :text="$t('importantLinks')"
      font="black"
      back="white"
    ></page-header>

    <b-container>
      <div class="link-items">
        <router-link to="/catalogue/hawk">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>
            {{ $t("catalogue") }} ON-LINE
          </div>
        </router-link>
        <router-link to="/pricelist">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>{{ $t("pricelist") }}
          </div>
        </router-link>
        <a href="http://www.hawkperformance.com/" target="_blank">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>
            {{ $t("website") }}
          </div>
        </a>
        <a href="https://www.youtube.com/user/HAWKPERFORMANCE" target="_blank">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>
            {{ $t("youtube") }}
          </div>
        </a>
      </div>
      <!-- <div class="youtube-wrapper">
        <div class="youtube">
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/sttWds7JtWY"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div>
          <p>GOODWOOD Festival of Speed - Budweiser Indy 500 Car</p>
          <p>We are proud to have had our 1978 Lightning Cosworth attend the 2014 Goodwood Festival of Speed, it is such an iconic event. Sit back, relax, and enjoy an exclusive look inside the Festival of Speed.</p>
          <p>*Listen with headphones*</p>
        </div>
      </div>-->
      <brands class="brands" />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Brands from "@/components/brands/Brands.vue";
import PageHeader from "@/components/common/PageHeader.vue";

export default {
  name: "HawkPl",
  components: { Brands, PageHeader },
  computed: {
    ...mapGetters(["isUserLogged"]),
  },
};
</script>
